import { apiParams, apiSlice } from '../../../store/Api';
import { DeliveryAddress, User } from '../Types';

export const profileApiSlice = apiSlice.injectEndpoints({
  endpoints: builder => ({
    getUser: builder.query<User, void | null>({
      query: () => ({
        url: apiParams.paths.users,
        method: apiParams.methods.POST,
      }),
    }),
    updateUserAddress: builder.mutation<DeliveryAddress, { id: string; deliveryAddress: DeliveryAddress }>({
      query: ({ id, deliveryAddress }) => ({
        url: `${apiParams.paths.users}/${id}`,
        method: apiParams.methods.PATCH,
        body: deliveryAddress,
      }),
      transformResponse: (_res, _meta, { deliveryAddress }) => deliveryAddress,
    }),
  }),
});

export const { useGetUserQuery, useUpdateUserAddressMutation } = profileApiSlice;
